export const changeTariff = async (isOwner: boolean) => {
    // @ts-ignore
    const url = helpable.replaceUrlParameters(routable.getRoute('openChangeTariffPopup'), {
        // @ts-ignore
        _prolong_: NEED_PROLONG,
    });
    if (isOwner) {
        // @ts-ignore
        $.modalable('open', {
            url,
        });
    } else {
        // @ts-ignore
        $.modalable('open', {
            content: `<div>${i18next.t('useDashboard.return.changeTariff.content')}</div>`,
        });
    }
};
